export const MAX_FEEDBACK_LENGTH = 2000;
export const MAX_FILES = 50;
export const MAX_FILE_SIZE_BYTES = 25 * 1024 * 1024;
export const FEEDBACK_CATEGORY = "WEB_EXPERIENCE";
export const DEFAULT_SATISFACTORY_RATING = 5;

export const ACCEPTED_EXTENSIONS = [
  "jpg",
  "jpeg",
  "png",
  "pdf",
  "docx",
  "xlsx",
  "csv",
  "mp4",
  "mp3",
];

/** Shown via `t(i18nKey)`; `apiValue` is sent in `issuesFaced` (stable English for backend / analytics). */
export const FEEDBACK_ISSUE_OPTIONS = [
  { apiValue: "Ask a question", i18nKey: "feedback_issue_ask_question" },
  { apiValue: "Leave a comment", i18nKey: "feedback_issue_leave_comment" },
  { apiValue: "Report a bug", i18nKey: "feedback_issue_report_bug" },
  {
    apiValue: "Suggest an improvement",
    i18nKey: "feedback_issue_suggest_improvement",
  },
] as const;
